import { render, staticRenderFns } from "./CadastroModalidadeDicom.vue?vue&type=template&id=cb153f54&"
import script from "./CadastroModalidadeDicom.vue?vue&type=script&lang=js&"
export * from "./CadastroModalidadeDicom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports